import VueMeta from 'vue-meta';
import VTooltip from 'v-tooltip';

// Libraries that don't require any setup beyond a simple `Vue.use` call don't
// need their own initializer.
export default function (Vue) {
  Vue.use(VueMeta);
  Vue.use(VTooltip);
}
